module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-icon-white-logo-176333eeb7e0dbfff3751ba0513f4a50.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/logo/paypal-icon-white-logo.svg
// module id = PHfI
// module chunks = 24